import { motion } from 'framer-motion'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-center"
        >
          <div className="flex flex-col md:flex-row items-center justify-center gap-2 text-sm text-gray-400">
            <p className="flex items-center gap-2">
              <svg className="w-4 h-4 text-violet-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
              </svg>
              <span>&copy; {currentYear} <span className="font-semibold text-white">D Cube International</span></span>
            </p>
            <span className="hidden md:inline text-gray-600">•</span>
            <p>All rights reserved</p>
            <span className="hidden md:inline text-gray-600">•</span>
            <p className="flex items-center gap-1">
              <span className="text-gray-500">Developed by</span>
              <span className="font-semibold text-white">Raheesh Ramsy</span>
              <span className="text-gray-600">-</span>
              <span className="text-violet-400">AI Developer</span>
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  )
}

export default Footer
